import {
  RemoteBrandLogo,
  FooterBottom,
  Copyright as CopyrightComponent,
  SocialLink,
} from 'remote-com-shared/components/Footer/styles';
import styled from 'styled-components';

import { FooterContainerWrapper } from './WebinarFooter';

const currentYear = new Date().getFullYear();

const FooterBottomWrapper = styled(FooterBottom)`
  border: none;

  ${SocialLink} {
    padding-top: 5px;
  }
`;

export const Copyright = styled(CopyrightComponent)`
  font-family: var(--typography-fontBrand);
  color: var(--colors-blank);
  opacity: 1;
`;

export const BenefitsFooter = () => (
  <FooterContainerWrapper>
    <FooterBottomWrapper>
      <SocialLink
        href="https://remote.com"
        target="_blank"
        rel="noreferrer"
        aria-label="Visit Remote"
      >
        <RemoteBrandLogo />
      </SocialLink>
      <Copyright>© {currentYear} Remote Technology, Inc.</Copyright>
    </FooterBottomWrapper>
  </FooterContainerWrapper>
);
